import {ActionResponse} from "../AuthProvider/AuthProviderActions";
import moment from "moment";

export interface ItemsDispatcher{
    type?:"REQUEST" | "SUCCESS" | "ERROR",
    payload?: ItemData,
    error?:string
}

export interface ItemData {
    items:GalleryItemData[]
    isLoading?: boolean
    itemsMessage?:string
    itemsMessageVariant?:"success" | "danger" | "warning" | "info" | "default"
}

export interface IGalleryItemData{
    id: string;
    name: string;
    mime_type: string;
    size: number;
    validity: string;
    created: string;
    file_description:string;
}

export class GalleryItemData implements IGalleryItemData{
    public id: string;
    public name: string;
    public mime_type: string;
    public size: number;
    public validity: string;
    public created: string;
    public file_description:string;

    private filesize = require('file-size');

    constructor( data:IGalleryItemData ) {
        this.id = data.id
        this.name = data.name
        this.mime_type = data.mime_type
        this.size = data.size
        this.validity = data.validity
        this.created = data.created
        this.file_description = data.file_description
    }

    get is_image() {
        return this.mime_type.includes('image')
    }

    get created_date(){
        return moment( this.created )
    }
    get validity_date(){
        return moment( this.validity )
    }
    get human_valid(){
        const duration = moment.duration(this.validity_date.diff( moment() ));
        return duration.humanize()
    }
    get human_size(){
        return this.filesize( this.size ).human('jedec')
    }
    get human_type(){
        const elements = this.mime_type.split('/')
        return '.' + elements[ elements.length - 1 ]
    }

    public sort( other:GalleryItemData , order:number):number{
        switch ( order ){
            case 1:
                return this.size - other.size
            case 2:
                return other.size - this.size
            case 3:
                return this.created_date.valueOf() - other.created_date.valueOf()
            case 4:
                return other.created_date.valueOf() - this.created_date.valueOf()
            case 5:
                return this.validity_date.valueOf() - other.validity_date.valueOf()
            case 6:
                if( this.name > other.name ){ return 1 }
                if( this.name < other.name ){ return -1 }
                return 0
            case 7:
                if( this.name > other.name ){ return -1 }
                if( this.name < other.name ){ return 1 }
                return 0
            default:
                return 0
        }
    }
}

export interface ItemsActionResponse extends ActionResponse{
    response: IGalleryItemData[]
}

export interface ItemsGetFilesResponse extends ActionResponse{
    response: string
}

export const orderData = [
    'Sin Orden',
    'De menor a mayor tamaño',
    'De mayor a menor tamaño',
    'Mas recientes',
    'Mas antiguos',
    'Proximos a vencer',
    'Por nombre',
    'Por nombre decendente'
]